import { useState } from 'react';

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

import { handleHttpErrorStatus } from '../../../../utils/handleHttpErrorStatus';
import { labelStyles } from '../../../../common/styles/formStyles';
import Grid from '@mui/material/Grid';
import {hetch} from "../../../../utils/fetch.hooked";

const formRegex = {
  serialNumber: /[^0-9a-zA-Z-]/g,
  companyName: /[^0-9a-zA-Zа-яА-ЯёЁ"«»\s]/g
}

const applyRegex = (inputName) => {
  return formRegex[inputName];
}

function AddLicenseForm({ triggerRefetch, handleClose }) {
  const [isFetching, setIsFetching] = useState(false);
  const [formValues, setFormValues] = useState({serialNumber: '', companyName: ''});
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (evt) => {
    const { name, value } = evt.target;
    setFormValues({
      ...formValues,
      [name]: value.replace(applyRegex(name), ''),
    });
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setSubmitted(true);
    setError('');

    if (Object.values(formValues).every((value) => value)) {
      setIsFetching(true);
      hetch('/api/licenses', {
        headers: {'Content-Type': 'application/json'},
        method: 'POST',
        body: JSON.stringify({
          serial_number: formValues.serialNumber,
          company_name: formValues.companyName
        }),
      })
        .then(handleHttpErrorStatus)
        .then(() => {
          handleClose();
          triggerRefetch();
        })
        .catch(err => err.json())
        .then(res => {
          if (res) {
            setError(res.message);
          }
        })
        .finally(() => {
          setIsFetching(false);
        });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {error ? (
          <Grid item xs={12}>
            <Alert severity="error">{error}</Alert>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <InputLabel htmlFor='serialNumber' sx={labelStyles} required={true}>
            Серийный номер
          </InputLabel>
          <TextField
            id='serialNumber'
            name='serialNumber'
            size="small"
            fullWidth
            error={submitted && !formValues.serialNumber}
            disabled={isFetching}
            value={formValues.serialNumber}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel htmlFor='companyName' sx={labelStyles} required={true}>
            Наименование организации
          </InputLabel>
          <TextField
            id='companyName'
            name='companyName'
            size="small"
            fullWidth
            error={submitted && !formValues.companyName}
            disabled={isFetching}
            value={formValues.companyName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Button
            title="Сохранить лицензию"
            variant='contained' type='submit'
            disabled={isFetching}
          >
            Сохранить
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default AddLicenseForm;
